import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AppSettings } from '../enums/app-settings.enum';
import { AlertService } from '../services/alert.service';
import { LanguageSwitchService } from '../services/language-switch.service';
@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  ANURL: string;
  constructor(
    private LSS: LanguageSwitchService,
    private ALS: AlertService,
    private toastController: ToastController
  ) { }

  getLocaleLanguage(): string {
    const language = this.LSS.getLanguage();
    if (language) return language;
    else {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }
    }
    return 'en';
  }

  log(D: any) {
    // console.log(D);
  }
  error(E: any) {
    this.ALS.error(E);
    this.toast(E);
  }
  clearError() {
    this.ALS.clearAll();
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  createCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = ';expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires;
    return '';
  }
  async toast(M: string) {
    const toast = await this.toastController.create({
      message: `${M}`,
      duration: 2000,
    });
    toast.present();
  }

  getHeaders() {
    const req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase();
  }

  uniqByKeepLast(a, key) {
    return [...new Map(a.map((x) => [key(x), x])).values()];
  }
  uniqByKeepFirst(a, key) {
    let seen = new Set();
    return a.filter((item) => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  getBrowserInfo = function () {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    return browserName;
  };

  setENV(e) {
    localStorage.setItem('ENV', e);
  }

  getENV() {
    const e = localStorage.getItem('ENV');
    if (e) {
      if (e == 'mobile') {
        return e;
      } else {
        return 'web';
      }
    } else {
      return 'web';
    }
  }

  setAccessToken(e) {
    localStorage.setItem('AccessToken', e);
  }

  getAccessToken() {
    const e = localStorage.getItem('AccessToken');
    if (e) {
      return e;
    }
    return null;
  }


  setJSessionID(e) {
    localStorage.setItem('JSESSIONID', e);
    document.cookie = 'JSESSIONID=' + e;
  }
  setBigIpServer(e) {
    sessionStorage.setItem('BIGipServerb2cprod_443_pool', e);
    document.cookie = 'BIGipServerb2cprod_443_pool=' + e;
  }

  getJSessionID() {
    const e = localStorage.getItem('JSESSIONID');
    if (e) {
      return e;
    }
    return null;
  }

  getBigIpServer() {
    const e = sessionStorage.getItem('BIGipServerb2cprod_443_pool');
    if (e) {
      return e;
    }
    return null;
  }

  isMobileDevice() {
    return /Mobi/i.test(window.navigator.userAgent);
  }

  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = (/android/i.test(userAgent)) ? true : false;
    if (isAndroid) {
      return 'Android';
    }
    return 'iOS';
  }

 public convertIncommingDateToSysReadableDate(D: string) {
    if (D) {
      const dateParts = D.split(/[\s/:]+/); // Split the string into date and time parts
      // Parse the date parts
      const month = (dateParts[1]) ? parseInt(dateParts[0]) : null; // Months are zero-indexed
      const day = (dateParts[0]) ? parseInt(dateParts[1]) : null;
      const year = (dateParts[2]) ? parseInt(dateParts[2]) : null;
      const hour = (dateParts[3]) ? parseInt(dateParts[3]) : null;
      const minute = (dateParts[4]) ? parseInt(dateParts[4]) : null;
      const second = (dateParts[5]) ? parseInt(dateParts[5]) : null;

      // Create a new Date object with the adjusted timezone offset
      const date = new Date(year, month, day, hour, minute, second);
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);

      return date;
    }
    return new Date();
  }
}
